const TEAM_ACTIVITY_TYPES = {
  comments: "COMMENTS",
  commits: "COMMITS",
  pullRequests: "PULL_REQUESTS",
  pullRequestMerges: "PULL_REQUEST_MERGES",
  reviews: "REVIEWS",
};

export default TEAM_ACTIVITY_TYPES;
